module.exports = __webpack_public_path__ + "images/9_NOON_Switches.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feeds/9_NOON_Switches.png
// module id = 266
// module chunks = 0